export const isEmbedEnabled = ({ videoItem, channelData }) => (
    channelData.premiumOwner && _.get(videoItem, 'embedOptions.enabled') !== false
);



// WEBPACK FOOTER //
// ./src/widget/selectors/embed.js